import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/chapter_table'
import ChapterService from '../../network/services/chapter'
import { serialize } from '../../network/request'
import ChapterTable from './ChapterTable'

const ChapterPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Chapter
    </Button>
  )

  return (
    <PageHeader title="All Chapters" extra={[primaryAction]}>
      <Card>
        <ChapterTableWrapper />
      </Card>
    </PageHeader>
  )
}

const ChapterTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(ChapterService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = ChapterService.toPaginate(response)

  return (
    <>
      <ChapterTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <ChapterTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default ChapterPage
